import { ThemeOptions } from '@mui/material/styles';

/**
 * Elegant Gold Theme
 * Primary: Gold (#b8860b)
 * Secondary: Dark Blue (#2c3e50)
 * Target: Luxury pawn shops
 */
export const elegantGoldTheme: ThemeOptions = {
    palette: {
        mode: 'light',
        primary: {
            main: '#b8860b',
            light: '#d4af37',
            dark: '#8b6508',
            contrastText: '#fff',
        },
        secondary: {
            main: '#2c3e50',
            light: '#34495e',
            dark: '#1a252f',
            contrastText: '#fff',
        },
        background: {
            default: '#fafaf8',
            paper: '#ffffff',
        },
        text: {
            primary: '#2c3e50',
            secondary: '#7f8c8d',
        },
        error: {
            main: '#c0392b',
        },
        warning: {
            main: '#e67e22',
        },
        info: {
            main: '#3498db',
        },
        success: {
            main: '#27ae60',
        },
    },
    typography: {
        fontFamily: [
            'Georgia',
            '"Times New Roman"',
            'serif',
            '-apple-system',
            'BlinkMacSystemFont',
        ].join(','),
        h1: {
            fontWeight: 600,
            letterSpacing: '0.02em',
        },
        h2: {
            fontWeight: 600,
            letterSpacing: '0.02em',
        },
        h6: {
            fontWeight: 600,
            letterSpacing: '0.01em',
        },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 4px 20px rgba(184, 134, 11, 0.15)',
                    border: '1px solid rgba(184, 134, 11, 0.1)',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#2c3e50',
                    borderRight: '2px solid #b8860b',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    borderBottom: '2px solid #b8860b',
                },
            },
        },
    },
};
